//
// Centralised in-app link builders. Each function returns a path string
// with query params, preserving partner context (?i=) where relevant.
//

import casesStatusParam from './cases/casesStatusParam';
import casesTeamsParam from './cases/casesTeamsParam';

function buildUrl(path, params) {
  const entries = Object.entries(params).filter(([, v]) => ((v !== null) && (v !== undefined)));
  if (!entries.length) return path;
  return `${path}?${entries.map(([k, v]) => `${k}=${v}`).join('&')}`;
}

const appLinks = {
  dashboard: () => '/home',
  tasksList: (params) => buildUrl(
    '/tasks/list',
    {
      tab: params?.tab,
      cs: params?.csid,
    },
  ),
  casesList: (params) => buildUrl(
    '/cases/list',
    {
      [casesTeamsParam]: params?.gpids?.join(',') || null,
      [casesStatusParam]: params?.statuses?.join(',') || null,
    },
  ),
  casesListCase: (params) => buildUrl(
    '/cases/list',
    {
      cs: params?.csid,
      i: params?.piid,
      [casesTeamsParam]: params?.gpids?.join(',') || null,
      [casesStatusParam]: params?.statuses?.join(',') || null,
    },
  ),
  qrsList: (params) => buildUrl(
    '/qrs/list',
    {
      q: params?.qrid,
      i: params?.piid,
      f: params?.folderId,
    },
  ),
  qrsModels: (params) => buildUrl(
    '/qrs/models',
    {
      t: params?.qtid,
      i: params?.piid,
    },
  ),
  qrsPrinting: (params) => buildUrl(
    '/qrs/printing',
    { i: params?.piid },
  ),
  pollSettings: (params) => buildUrl(
    '/polls/settings',
    {
      p: params?.pollId,
      i: params?.piid,
    },
  ),
  pollResults: (params) => buildUrl(
    '/polls/results',
    {
      p: params?.pollId,
      pi: params?.pollItemId,
      z: params?.zoom,
      i: params?.piid,
    },
  ),
  commSettings: (params) => buildUrl(
    '/comm/faq',
    {
      c: params?.commId,
      i: params?.piid,
    },
  ),
  commFeedbacks: (params) => buildUrl(
    '/comm/feedbacks',
    { i: params?.piid },
  ),
  casesStats: (params) => buildUrl(
    '/cases/stats',
    {
      z: params?.zoom,
      i: params?.piid,
    },
  ),
  respondersTeams: (params) => buildUrl(
    '/responders/teams',
    {
      g: params?.gpid,
      r: params?.rlid,
    },
  ),
  respondersMissions: () => '/responders/missions',
  partnersSent: (params) => buildUrl(
    '/partners/sent',
    { i: params?.piid },
  ),
  partnersReceived: (params) => buildUrl(
    '/partners/received',
    { i: params?.piid },
  ),
  settingsLicenses: (params) => buildUrl(
    '/settings/licenses',
    { l: params?.liid },
  ),
  settingsSites: (params) => buildUrl(
    '/settings/licenses',
    { s: params?.siid },
  ),
  settingsFiles: () => buildUrl('/settings/files'),
  // A crop is a key inside its drawing file
  settingsPlans: (params) => buildUrl(
    '/settings/plans',
    {
      f: params?.fileUid,
      c: params?.cropKey,
    },
  ),
};

export default appLinks;
